<template>
  <div>
    <fetch-error
      v-if="data instanceof FetchError"
      @retry="error = null"
      :error="data"
    ></fetch-error>
    <loader v-else-if="data === null"></loader>
    <template v-else>
      <div>
        <vs-row style="margin: 0 -4px" class="shortcut-btns-cont">
          <vs-col class="options-btn-col" vs-lg="2" vs-sm="4" vs-xs="4">
            <vs-button
              @click="showCreateCategoryPopup = true"
              class="options-btn"
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-plus"
            >
              دسته بندی</vs-button
            >
          </vs-col>
          <vs-col class="options-btn-col" vs-lg="2" vs-sm="4" vs-xs="4">
            <vs-button
              @click="showCreateSubCategoryPopup = true"
              class="options-btn"
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-plus"
            >
              زیر دسته</vs-button
            >
          </vs-col>
          <vs-col class="options-btn-col" vs-lg="2" vs-sm="4" vs-xs="4">
            <vs-button
              @click="showCreateProductPopup = true"
              class="options-btn"
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-plus"
            >
              محصول</vs-button
            >
          </vs-col>
        </vs-row>
        <div style="padding: 40px 0 60px 0" class="flex-1">
          <div style="display: flex; flex: 1">
            <category
              v-model="activeCategory"
              :categories="data || []"
              @edit="editCategory"
              @remove="deleteCategory"
            >
            </category>
          </div>
          <swiper
            class="swiper"
            @slideChange="slideChange"
            :options="swiperOption"
          >
            <swiper-slide v-for="categoryItem in data" :key="categoryItem.id">
              <div
                v-if="categoryItem.id === activeCategory.id"
                class="products"
              >
                <products
                  :activeCategory="activeCategory"
                  :categories="data || []"
                  @delete="deleteProduct"
                  @productCategoryChanged="productCategoryChanged"
                  @subCategoryDeleted="subCategoryDeleted"
                  @subCategoryChanged="subCategoryChanged"
                ></products>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>

      <vs-popup
        v-if="showCreateProductPopup"
        title="افزودن محصول"
        :active.sync="showCreateProductPopup"
      >
        <product-input
          v-model="productModel"
          :activeCategory="activeCategory"
          :categories="data || []"
          :createMode="true"
          @productAdded="productAdded"
          @close="showCreateProductPopup = false"
        ></product-input>
      </vs-popup>
      <vs-popup
        v-if="showCreateCategoryPopup"
        title="افزودن دسته بندی"
        :active.sync="showCreateCategoryPopup"
      >
        <category-input
          v-model="categoryModel"
          :categories="data || []"
          :createMode="true"
          @close="showCreateCategoryPopup = false"
          @categoryAdded="categoryAdded"
        ></category-input>
      </vs-popup>
      <vs-popup
        v-if="showCreateSubCategoryPopup"
        title="افزودن زیر دسته"
        :active.sync="showCreateSubCategoryPopup"
      >
        <sub-category-input
          v-model="categoryModel"
          :categories="data || []"
          :createMode="true"
          @close="showCreateSubCategoryPopup = false"
          @subCategoryAdded="subCategoryAdded"
          :activeCategory="activeCategory"
        ></sub-category-input>
      </vs-popup>
      <vs-popup
        v-if="showEditCategoryPopup"
        title="ویرایش دسته بندی"
        :active.sync="showEditCategoryPopup"
      >
        <category-input
          v-model="activeCategory"
          :categories="data || []"
          @close="showEditCategoryPopup = false"
          @categoryUpdated="categoryUpdated"
        ></category-input>
      </vs-popup>
    </template>
  </div>
</template>
<script>
import Category from "./../../ProductCategory.vue";
import Products from "./Products.vue";
import providerApiService from "../../../services/api/ProviderApiService";
import productApiService from "../../../services/api/ProductApiService";
import { mapGetters } from "vuex";
import FetchError from "../../../services/api/FetchError";
import ProductInput from "../ProductInput.vue";
import CategoryInput from "../CategoryInput.vue";
import SubCategoryInput from "../SubCategoryInput.vue";
import { isMobileView } from "../../../helpers/Functions";

export default {
  name: "Input",
  data() {
    return {
      FetchError,
      data: null,
      error: null,
      activeCategory: null,
      showCreateOrderPopup: false,
      user: null,
      showCreateProductPopup: false,
      showCreateCategoryPopup: false,
      showCreateSubCategoryPopup: false,
      showEditCategoryPopup: false,
      productModel: {
        available: true,
        details: { description: "" },
        discount: 0,
        thumbnail: null,
        level: null,
        price: "",
        title: "",
        // english_title: '',
        //unit: null
      },
      categoryModel: {
        thumbnail: null,
        title: "",
        level: 0,
        visible: true,
      },
      swiperOption: {
        allowTouchMove: isMobileView(),
      },
    };
  },
  components: {
    Category,
    Products,
    ProductInput,
    CategoryInput,
    SubCategoryInput,
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  watch: {
    activeCategory(item) {
      const categoryIndex = this.data.findIndex(
        (element) => element.id === item.id
      );

      const swiper = this.getSwiperSelector();

      if (swiper) {
        // Now you can use all slider methods like
        swiper.slideTo(categoryIndex, 0, false);
      }
    },
  },
  mounted() {
    this.getMenu();
  },
  methods: {
    getMenu() {
      providerApiService
        .menu(this.currentProvider.id)
        .then((res) => {
          this.data = res.data;
          if (res.data[0]) this.activeCategory = res.data[0];
        })
        .catch((err) => {
          this.data = err;
        });
    },
    deleteProduct(product, subCategory) {
      this.$vs.loading();
      productApiService
        .deleteProduct(this.currentProvider.id, product.id)
        .then(() => {
          this.productDeleted(product, subCategory);

          this.$vs.notify({
            text: "محصول با موفقیت حذف شد",
            color: "success",
            position: "bottom-center",
          });
        })
        .catch((err) => {
          this.$vs.notify({
            text: err.getErrorDescriptions(),
            color: "danger",
            position: "bottom-center",
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    deleteCategory(category) {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: `حذف محصول`,
        text: `از حذف دسته بندی "${category.title}" اطمینان دارید؟`,
        acceptText: "بلی",
        cancelText: "خیر",
        accept: () => {
          this.$vs.loading();
          productApiService
            .deleteCategory(this.currentProvider.id, category.id)
            .then(() => {
              this.categoryDeleted(category);

              this.$vs.notify({
                text: "دسته بندی با موفقیت حذف شد",
                color: "success",
                position: "bottom-center",
              });
            })
            .catch((err) => {
              this.$vs.notify({
                text: err.getErrorDescriptions(),
                color: "danger",
                position: "bottom-center",
              });
            })
            .finally(() => {
              this.$vs.loading.close();
            });
        },
      });
    },
    editCategory(category) {
      this.activeCategory = category;
      this.showEditCategoryPopup = true;
    },

    // Categories
    categoryAdded(resource) {
      this.activeCategory = resource;
      this.data.push({
        ...resource,
        items: [],
        subCategories: [],
        visible: +resource.visible,
      });
    },
    categoryUpdated(resource) {
      const currentCategoryIndex = this.data.findIndex(
        (element) => element.id === resource.id
      );
      this.activeCategory = {
        ...this.activeCategory,
        items: this.data[currentCategoryIndex].items.map((element) => {
          return {
            ...element,
            available: +resource.available,
          };
        }),
      };
      this.data[currentCategoryIndex].items = this.data[
        currentCategoryIndex
      ].items.map((element) => {
        return {
          ...element,
          available: +resource.available,
        };
      });
      this.data[currentCategoryIndex].title = resource.title;
      this.data[currentCategoryIndex].thumbnail = { ...resource.thumbnail };
      this.data[currentCategoryIndex].level = resource.level;
      this.data[currentCategoryIndex].visible = +resource.visible;
      this.data[currentCategoryIndex].available = +resource.available;
    },
    categoryDeleted(category) {
      this.data.splice(
        this.data.findIndex((item) => item.id === category.id),
        1
      );
    },

    // SubCategories
    subCategoryAdded(resource, category) {
      this.activeCategory = category;
      const categoryIndex = this.data.findIndex(
        (category) => category.id === this.activeCategory.id
      );
      this.data[categoryIndex].subCategories.push({ ...resource, items: [] });
    },
    subCategoryChanged(resource, category, subCategory) {
      const resourceWithItems = {
        ...resource,
        items: subCategory.items,
      };
      this.subCategoryDeleted(subCategory);
      this.subCategoryAdded(resourceWithItems, category);
    },
    subCategoryDeleted(subCategory) {
      let subCategories = [];
      const categoryIndex = this.data.findIndex(
        (d) => d.id === this.activeCategory.id
      );
      subCategories = this.data[categoryIndex].subCategories;
      subCategories.splice(
        subCategories.findIndex((item) => item.id === subCategory.id),
        1
      );
    },

    // Products
    productAdded(resource, category, subCategory) {
      this.activeCategory = category;
      const categoryIndex = this.data.findIndex(
        (category) => category.id === this.activeCategory.id
      );
      let subCategoryIndex = null;
      if (subCategory) {
        subCategoryIndex = this.data[categoryIndex].subCategories.findIndex(
          (element) => element.id === subCategory.id
        );
        this.data[categoryIndex].subCategories[subCategoryIndex].items.push(
          resource
        );
      } else {
        this.data[categoryIndex].items.push(resource);
      }
    },
    productDeleted(product, subCategory) {
      let items = [];
      let subCategoryIndex = null;
      const categoryIndex = this.data.findIndex(
        (d) => d.id === this.activeCategory.id
      );
      if (subCategory) {
        subCategoryIndex = this.data[categoryIndex].subCategories.findIndex(
          (element) => element.id === subCategory.id
        );
        items = this.data[categoryIndex].subCategories[subCategoryIndex].items;
      } else {
        items = this.data[categoryIndex].items;
      }
      const index = items.findIndex((element) => element.id === product.id);
      items.splice(index, 1);
    },
    productCategoryChanged(resource, category, subCategory) {
      this.productDeleted(resource, subCategory.current);
      this.productAdded(resource, category, subCategory.target);
    },
    slideChange() {
      const swiper = this.getSwiperSelector();

      if (swiper) {
        // Now you can use all slider methods like
        this.activeCategory = this.data[swiper.activeIndex];
      }
    },
    getSwiperSelector() {
      const swiperHtml = document.querySelector(".swiper");

      if (swiperHtml) {
        return swiperHtml.swiper;
      }

      return null;
    },
  },
};
</script>

<style scoped lang="scss">
.shortcut-btns-cont {
  position: fixed;
  left: 0;
  right: 0;
  top: 65px;
  z-index: 101;
  width: 100%;
  background-color: #fafafa;
  padding: 15px 35px;

  @media (min-width: 1200px) {
    left: 260px;
  }
}

.options-btn-col {
  padding: 0 4px;
  margin-bottom: 0;

  @media (max-width: 350px) {
    width: 50% !important;
  }

  @media (min-width: 600px) and (max-width: 900px) {
    width: 16.6% !important;
  }

  @media (min-width: 1100px) and (max-width: 1200px) {
    width: 12.5% !important;
  }

  @media (min-width: 1400px) {
    width: 10% !important;
  }

  .options-btn {
    width: 100%;
    padding: 0.5em !important;
  }
}

.products {
  display: flex;
  flex-direction: column;
  min-height: 600px;
}

.dropdown {
  z-index: 100;
  border-radius: 10px !important;
  overflow: hidden;
  background-color: #fff;
  position: absolute;
  width: 230px;
  right: 20px !important;

  @media (max-width: 600px) {
    left: 0 !important;
    right: 0 !important;
    margin: 0 auto;
  }
}
</style>
